/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Rollout visibility type INTERNAL for internal rollouts i.e not visible to tenants, EXTERNAL for external rollouts i.e visible to tenants.
 */
export type RolloutVisibility = 'INTERNAL' | 'EXTERNAL';

export const RolloutVisibility = {

    INTERNAL: 'INTERNAL' as RolloutVisibility,

    EXTERNAL: 'EXTERNAL' as RolloutVisibility
};

